import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import Button from "~/shared/ui/Fields/Button";
import Modal from "~/shared/ui/Fields/Modal";
import Select from "~/shared/ui/Fields/Select";
import { NOTIFICATIONS } from "~/constans/notifications";
import { SelectOption } from "~/entity/Employee/model/schema";
import { useGetAllLevelsForSelect } from "~/hooks/Selectors/useGetAllLevelsForSelect";
import {
  useAddNotificationMutation,
  useEditCurriculumPositionStudyProgramMutation,
} from "~/schemas/generated/graphql";

import s from "./ChangeCourseLevelModal.less";

interface IChangeCourseLevelModal {
  isShowModal: boolean;
  onHandleCloseModal: () => void;
  level;
  course;
  refetch;
}
const ChangeCourseLevelModal = (props: IChangeCourseLevelModal) => {
  const { isShowModal, onHandleCloseModal, level, course, refetch } = props;

  const { id } = useParams<{ id: string }>();

  const { t } = useTranslation();
  const [addNotificationMutation] = useAddNotificationMutation({});

  const defaultValues = {
    level: {
      label: level.name,
      value: level.id,
    },
  };

  const { control, handleSubmit } = useForm({
    defaultValues,
  });

  const { levels, searchText, intersectionObserver } =
    useGetAllLevelsForSelect();

  const [changeLevel] = useEditCurriculumPositionStudyProgramMutation({
    onCompleted: () => {
      refetch();
      onHandleCloseModal();
    },
    onError: (vals) => {
      addNotificationMutation({
        variables: {
          type: NOTIFICATIONS.error,
          content: vals["message"],
        },
      });
    },
  });

  const onHandleSubmit = (data: { level: SelectOption }) => {
    const { level } = data;

    changeLevel({
      variables: {
        PositionGroupId: id,
        LevelId: level.value,
        CourseId: course.id,
      },
    });
  };

  return (
    <Modal
      title={"Изменение уровня"}
      isOpen={isShowModal}
      actionClose={onHandleCloseModal}
      customClassLayout={s.modal_layout}
    >
      <form className={s.wrapper}>
        <span className={s.text}>
          Изменение уровня у курса{" "}
          <span className={s.title}>{course.name}</span>
        </span>
        <div className={s.level}>
          <div className={s.status_label_wrapper}>
            <label className={s.label}>Уровень</label>
          </div>
          <div className={s.status_select_wrapper}>
            <Select
              name={"level"}
              defaultValue={{ value: level.id, label: level.name }}
              control={control}
              customClassName={s.status_select}
              customClassDesck={s.status_input}
              getSearchText={searchText}
              onScrollBottom={intersectionObserver}
              optionObjects={levels}
            />
          </div>
        </div>
        <div className={s.buttons}>
          <Button small txtBtn={t("ui.cancel")} onClick={onHandleCloseModal} />
          <Button
            small
            txtBtn={t("ui.save")}
            onClick={handleSubmit(onHandleSubmit)}
          />
        </div>
      </form>
    </Modal>
  );
};

export default ChangeCourseLevelModal;
